import Vue from 'vue';
import { getMemberList } from '../../../services/personnelService/contactsService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  memberList: [],
  pagination: {
    current_page: 0,
    per_page: 20
  }
};

// getters
const getters = {};

// actions
const actions = {
  // 取得顧問 Profile
  async getMemberListHandler({ commit }, paginationInfo) {
    paginationInfo.sort_by = 'note_name';
    paginationInfo.sort_direction = 'asc';
    const data = await getMemberList(paginationInfo);
    commit('setMemberList', data);
  }
};

// mutations
const mutations = {
  setMemberList(state, data) {
    Vue.set(state, 'memberList', state.memberList.concat(data.data.members));
    Vue.set(state, 'pagination', data.pagination);
  },
  resetHandler(state) {
    Vue.set(state, 'memberList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 20
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
